import React from 'react';
import PropTypes from 'prop-types';

import { Expandable } from 'sharedComponents';
import { translate } from 'helpers/translateHelper';
import LimitTitle from './LimitTitle';
import Limit from './Limit';
import { IconCaretRight, IconDropDownMo } from 'svgIcons/MotionPortalIcons';

const PersonalLimit = ({ timeSeries, userLimits, isExpanded, expandedItem, setExpandedItem, setIsExpanded, checkIsSmseAsset, expandItemName, ...props }) => {
    const { model } = props;
    const notificationCount = userLimits.filter((limit) => limit?.notificationEnabled)?.length;

    const handleExpandPersonalLimits = (signalUniqId) => {
        let expandedSignals = [...expandedItem];
        if (expandedSignals?.includes(signalUniqId)) {
            expandedSignals = expandedSignals.filter((id) => signalUniqId !== id);
        } else {
            expandedSignals?.push(signalUniqId);
        }
        setExpandedItem(expandedSignals);
    };

    return <div className='personal-limit-container'>
        <Expandable
            disabled={!timeSeries?.displayName}
            style={{ border: '1px solid #bababa' }}
            open={expandedItem?.includes(`P_${expandItemName}`)}
            onClick={() => handleExpandPersonalLimits(`P_${expandItemName}`)}
            key={`P_${expandItemName}`}
            collapsedIcon={<IconCaretRight />}
            expandedIcon={<IconDropDownMo />}
            title={
                <LimitTitle
                    {...props}
                    item={timeSeries}
                    setExpandedItem={setExpandedItem}
                    open={!timeSeries?.displayName ? false : isExpanded || expandedItem?.includes(`P_${expandItemName}`)}
                    expandedItem={expandedItem}
                    setIsExpanded={setIsExpanded}
                    isUserLimit={true}
                    showDiscard={userLimits?.filter((l) => l?.isModified)?.length > 0}
                    notificationCount={notificationCount}
                    checkIsSmseAsset={checkIsSmseAsset}
                    handleExpandSignal={handleExpandPersonalLimits}
                />
            }
        >
            <div className='content-container' id={timeSeries?.uniqId}>
                {userLimits?.length === 0 &&
                    <div className='limit-type-container'>
                        <div className='no-limits'>
                            {translate('ABB.Powertrain.Frontend.noLimitsMessage')}
                        </div>
                    </div>
                }
                {userLimits?.length > 0 &&
                    userLimits?.map(limit =>
                        <Limit key={limit.uniqId} item={limit} timeSeries={timeSeries} kpiList={model.limitKPI.kpiList} />
                    )
                }
            </div>
        </Expandable>
    </div>;
};

PersonalLimit.propTypes = {
    timeSeries: PropTypes.shape({
        uniqId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Unique identifier for the time series
        displayName: PropTypes.string, // Display name of the time series
    }), // The time series data
    userLimits: PropTypes.arrayOf(
        PropTypes.shape({
            uniqId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Unique identifier for the limit
            notificationEnabled: PropTypes.bool, // Whether notifications are enabled for the limit
            isModified: PropTypes.bool, // Whether the limit is modified
        })
    ), // Array of user-defined limits
    isExpanded: PropTypes.bool, // Whether the personal limit section is expanded
    expandedItem: PropTypes.arrayOf(PropTypes.string), // Array of expanded items
    setExpandedItem: PropTypes.func, // Function to set the expanded items
    setIsExpanded: PropTypes.func, // Function to toggle the expanded state
    checkIsSmseAsset: PropTypes.bool, // Whether the asset is an SMSE asset
    expandItemName: PropTypes.string, // Name of the item to expand
    model: PropTypes.shape({
        limitKPI: PropTypes.shape({
            kpiList: PropTypes.arrayOf(
                PropTypes.shape({
                    timeseries: PropTypes.arrayOf(
                        PropTypes.shape({
                            timeseriesNameTextKey: PropTypes.string, // Text key for the timeseries name
                        })
                    ),
                })
            ),
        }),
    }), // Model data containing KPI information
};


export default React.memo(PersonalLimit);
